import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class EmployeesAssetsHeader extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  handleExport = (e) => {
    e.preventDefault();
    this.props.handleExport();
  };

  render = () => (
    <Common.Header title={this.props.t('reports.employeesAssets.title')}></Common.Header>
  );
}

export default translate()(EmployeesAssetsHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/employees_assets/EmployeesAssetsReportHeader.js